import { useEffect, useState } from "react";

function useParallax(backgroundImage: string) {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    function handleScroll() {
      setOffset(window.scrollY);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return {
    backgroundPositionY: `calc(50% + ${offset * 0.5}px)`,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
  };
}

export default useParallax;
